import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import CommentIcon from '../../Icons/Comment';
import Notification from '../../Notifications/Notification';
var DeleteNotification = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteNotification, _super);
    function DeleteNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUndo = function () {
            _this.props.onUnhide(_this.props.comment);
        };
        return _this;
    }
    DeleteNotification.prototype.render = function () {
        var _a = this.props, id = _a.id, t = _a.t;
        return (React.createElement(Notification, { id: id, iconComponent: CommentIcon, actions: [
                {
                    type: 'negative',
                    label: t('comment.action.delete.undo'),
                    onClick: this.onUndo,
                },
            ] }, t('comment.info.deleted')));
    };
    return DeleteNotification;
}(React.Component));
export { DeleteNotification };
export default withTranslation()(DeleteNotification);
//# sourceMappingURL=DeleteNotification.js.map